// composables/useSanitizeForm.js
import DOMPurify from 'dompurify';

export function useSanitizeForm() {

    function sanitizeForm(form) {

        const sanitized = {};

        for (const key in form) {

        if (typeof form[key] === 'string') {

                sanitized[key] = DOMPurify.sanitize(form[key]);

            } else if (Array.isArray(form[key])) {

                sanitized[key] = form[key].map(item =>
                    typeof item === 'string' ? DOMPurify.sanitize(item) : item
                );

            } else {
                sanitized[key] = form[key];
            }

        }

            return sanitized;
        }

    return { sanitizeForm };
}
